/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React from 'react';
//@ts-ignore
import Parse from 'parse';
//@ts-ignore
import BackButton from './../back-button/./back-button';
//@ts-ignore
import ProductTile from './../product-tile/./product-tile';
//@ts-ignore
import {HeaderHeight,MobileHeaderHeight,ModelYear} from  './../../themes/kent/utilities/constants';

const WakeboardQuestions:any = [
  {
    "name":"Gender",
    "filter":"gender",
    "question":"WHAT IS YOUR GENDER?",
    "answers": ["mens" , "womens", "kids"],
    "values": ["mens" , "womens", "kids"],
    "answered":false,
    "answer":""
  },
  {
    "name":"Experience",
    "filter":"wakeboardSkill",
    "question":"HOW EXPERIENCED ARE YOU?",
    "answers": ["beginner" , "intermediate", "advanced"],
    "values": ["beginner" , "intermediate", "advanced"],
    "answered":false,
    "answer":""
  },
  {
    "name":"Type",
    "filter":"wakeboardType",
    "question":"WHERE DO YOU RIDE?",
    "answers": ["boat", "cable"],
    "values": ["boat" , "cable"],
    "answered":false,
    "answer":""
  },
  {
    "name":"Pop / Rocker",
    "filter":"wakeboardPopRocker",
    "question":"HOW DO YOU LIKE YOUR POP/ROCKER?",
    "answers": ["boosty", "mid", "consistent"],
    "values": ["boosty" , "mid", "consistent"],
    "answered":false,
    "answer":""
  }
  ,
  {
    "name":"Flex",
    "filter":"wakeboardFlex",
    "question":"HOW FLEXY DO YOU LIKE YOUR RIDE?",
    "answers": ["flexy", "mid flex"],
    "values": ["flexy" , "mid flex"],
    "answered":false,
    "answer":""
  }
]

const SurfQuestions:any = [
  {
    "name":"Style",
    "filter":"wakesurfStyle",
    "question":"WHAT IS YOUR SURF STYLE?",
    "answers": ["skim" , "surf", "cross"],
    "values": ["skim" , "surf", "cross"],
    "answered":false,
    "answer":""
  },
  {
    "name":"Skill",
    "filter":"wakesurfSkill",
    "question":"HOW EXPERIENCED ARE YOU?",
    "answers": ["beginner" , "intermediate", "advanced"],
    "values": ["beginner" , "intermediate", "advanced"],
    "answered":false,
    "answer":""
  },
  {
    "name":"Size",
    "filter":"wakesurfWakeSize",
    "question":"HOW BIG OF A WAKE DO YOU SURF?",
    "answers": ["standard" , "full-size", "gigantic"],
    "values": ["standard" , "full-size", "gigantic"],
    "answered":false,
    "answer":""
  },
]

interface IProps {
  type?:any;
  year?:any;
}

interface IState {
  questions?:any;
  updateKey?:any;
  products?:any;
  finderType?:any;
  currentQuestion?:any;
  category?:any;
  visibleQuestions?:any;
  quizCompleted?:any;
}

/**
 *
 * Tagged Image component
 * @extends {React.Component}
 */

class BoardFinder extends React.Component<IProps> {

  public state: IState;

  constructor(props: IProps) {
    super(props);
    this.state = {
      updateKey:0,
      products:[],
      currentQuestion: 0
    };
  }

  public componentDidMount = async() => {
    await this.setupQuestions();
    this.setupUI()
  }

  public setupQuestions = async() =>{
    let questions:any = WakeboardQuestions;
    let category:any = "tYeyYbLaJ5"
    if(this.props.type == "surf"){
        questions = SurfQuestions;
        category = "m28WAffc8i";
    }
    this.setState({
        questions:questions,
        category:category,
        finderType:this.props.type
    });
    return false
  }

  public setupUI = async()=>{
    let Products:any = Parse.Object.extend("Products"+ModelYear);
    let query:any = new Parse.Query(Products);
    query.equalTo("category",this.state.category)
    query.notEqualTo("subcategory","EYPAnD1L4c")
    query.ascending('order')
    query.equalTo('site','hyperlite')
    let results:any = await query.find()
    this.setState({
      allProducts : results,
      products : results
    })
    this.updateQuestions();
  }
  public updateQuestions = async() => {
    let visibleQuestions:any =[];
    let answeredQuestions:any = 0;
    this.state.questions.map((data:any, index:any)=>{
      if(data.name == "Flex" && this.state.questions[2].answer != "cable"){
        // do nothing
        data.answered = false;
        data.answer = "";
      } else if(data.name == "Pop / Rocker" && this.state.questions[2].answer != "boat"){
        // do nothing
        data.answered = false;
        data.answer = "";
      }
      else{
        visibleQuestions.push(data)
      }
      if(data.answered){
          answeredQuestions = answeredQuestions + 1;
      }
      if(index == this.state.questions.length -1){
        let quizCompleted:any = false;
        if(answeredQuestions == visibleQuestions.length){
          quizCompleted = true;
        }
        this.setState({
          visibleQuestions:visibleQuestions,
          quizCompleted:quizCompleted
        })
      }
    })
  }
  public breadcrumbClick = async(question:any) =>{
    this.state.visibleQuestions.map((data:any, index:any)=>{
      if(data.name == question.name){
        let currentQuestion:any = index;
        question.answered = false;
        question.answer = "";
        this.updateQuestions();
        this.filterProducts();
        this.setState({
          currentQuestion:currentQuestion
        })
      }
    })
  }
  public answerClick = async(question:any,answer:any) =>{
    this.state.questions.map((data:any)=>{
      if(data.name == question.name){
        let currentQuestion:any = this.state.currentQuestion+1;
        question.answered = true;
        question.answer = answer;
        this.updateQuestions();
        this.filterProducts()
        this.setState({
          currentQuestion:currentQuestion
        })
      }
    })
  }
  public filterProducts = async() => {
    let Products:any = Parse.Object.extend("Products"+ModelYear);
    let query:any = new Parse.Query(Products);
    this.state.questions.map(async(question:any, index:any) => {
      if(question.answer){
        query.equalTo(question.filter,question.answer)
      }
      if(index == this.state.questions.length -1){
        query.equalTo("category",this.state.category)
        query.notEqualTo("subcategory","EYPAnD1L4c")
        query.equalTo('site','hyperlite')
        query.ascending('order')
        let results:any = await query.find()
        let updateKey:any = this.state.updateKey +1;
        this.setState({
          updateKey:updateKey,
          products : results,
        })
      }
    })
  }

  public render(): JSX.Element {
    if(!this.state.visibleQuestions) return <span />
    let collapsedClass:any = null;
    let marginLeft:any  = this.state.currentQuestion * -100;
    let windowWidth:any = this.state.visibleQuestions.length * 100;
    let frameWidth:any = 100/this.state.visibleQuestions.length;
    if(this.state.quizCompleted){
      collapsedClass = "collapsed"
    }
    let headerHeight = HeaderHeight+50;
    if(window.outerWidth < 800){
      headerHeight = MobileHeaderHeight+50
    }
    return (
      <div className="hosports-board-finder light-grey-background">
        <div className="black-background" style={{paddingTop:headerHeight+"px"}}></div>
        <BackButton />
        <div id="questions" className={"black-background "+collapsedClass}>
          <div className="question-container" style={{width:windowWidth+'%',marginLeft:marginLeft+'%'}}>
            {this.state.visibleQuestions.map((question:any,index:any) => {
              var answeredClass = null;
              if(question.answered){
                answeredClass = "answered"
              }
              return(
                <div className={"question-frame full-width large-padding centered-text "+answeredClass} style={{width:frameWidth+'%'}}>
                  <h2 className="white">{question.question}</h2>
                  <div className="row tiny-padding small-top-margin">
                    {question.answers.map((answer:any,i:any)=>{
                      return(
                        <div className="small-12 medium-4 centered-text tiny-padding">
                          <div className="small-full-width button white-background black tiny-margin"  onClick={() => this.answerClick(question,answer)}>{answer}</div>
                        </div>
                      )
                    })}
                  </div>
                </div>
              )
            })}
          </div>
        </div>
        <div className="finder-breadcrumbs">
          {this.state.visibleQuestions.map((question:any,index:any) => {
            if(question.answered){
              return(
                <div  onClick={() =>this.breadcrumbClick(question)} className="button primary-color-background white tiny-margin global-radius uppercase" style={{margin:'5px',fontSize:"14px",whiteSpace:"nowrap"}}>{question.name+" : "+question.answer}</div>
              )
            } else{
              return(
                <div  onClick={() =>this.breadcrumbClick(question)} className="button white-background dark-grey global-radius uppercase" style={{margin:'5px', backgroundColor:'#f9f9f9', color:'#444',fontSize:"14px",whiteSpace:"nowrap"}}>{question.name}</div>
              )
            }
          })}
        </div>
        <div key={this.state.updateKey}>
          <div className={"row full-width section-padding small-padding"}>
            {this.state.products.map((data:any,index:any) => {
              return(
                <div key={data.id} className={"small-12 medium-3 large-3"}>
                  <ProductTile
                    product={data} />
                </div>
              )})}
          </div>
        </div>
      </div>
    );
  }
}

export default BoardFinder;
